import React, { FC } from 'react';
import { Button, CircularProgress } from 'drift-ui';
import styles from './ContinueButton.scss';
import { useTranslation } from 'react-i18next';
import cx from 'classnames';

type ContinueButtonProps = {
  handleContinueClick: () => void;
  isPatching: boolean;
  buttonStyles?: string;
  title?: string;
  'data-testid'?: string;
};

export const ContinueButton: FC<ContinueButtonProps> = ({
  handleContinueClick,
  isPatching,
  buttonStyles,
  title,
  'data-testid': testId,
}) => {
  const { t } = useTranslation();

  return (
    <Button
      data-testid={testId}
      className={cx(styles.continueButton, buttonStyles)}
      onClick={handleContinueClick}
      disabled={isPatching}
      loading={isPatching}
      onMouseDown={(e) => e.preventDefault()}
      loadingIndicator={<CircularProgress className={styles.patchLoadingIndicator} size={16} />}
      variant="contained"
      size="large"
    >
      {title || t('continue')}
    </Button>
  );
};

export default ContinueButton;
